import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CLIENT_THEME, ClientTheme } from 'src/app/features/client/';

@Component({
  selector: 'app-maintenance-mode',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './maintenance-mode.component.html',
  styleUrl: './maintenance-mode.component.scss',
})

export class MaintenanceModeComponent {

  clientTheme: ClientTheme;

    constructor() {
    this.clientTheme = CLIENT_THEME;
  }
}
